/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventTicketInfo,
    JsonEventTicketInfoFromJSON,
    JsonEventTicketInfoFromJSONTyped,
    JsonEventTicketInfoToJSON,
} from './JsonEventTicketInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventTicketInfo
 */
export interface ApiResultOfJsonEventTicketInfo {
    /**
     * 
     * @type {JsonEventTicketInfo}
     * @memberof ApiResultOfJsonEventTicketInfo
     */
    data?: JsonEventTicketInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventTicketInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventTicketInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventTicketInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventTicketInfo
     */
    result?: ApiResultOfJsonEventTicketInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventTicketInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventTicketInfoFromJSON(json: any): ApiResultOfJsonEventTicketInfo {
    return ApiResultOfJsonEventTicketInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventTicketInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventTicketInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventTicketInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventTicketInfoToJSON(value?: ApiResultOfJsonEventTicketInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventTicketInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

